import {dateTime} from "services/date";
import {Facility} from "types/Facility";
import {transformOpeningHours} from "../../opening-hours";

/**
 * Transform the given facility by deserializing object properties
 *
 * @internal
 * @param facility
 */
export default function deserializeFacility(facility: any): Facility {
    facility.created_at = dateTime(facility.created_at);
    facility.updated_at = dateTime(facility.updated_at);

    if (facility.notes) {
        facility.notes = facility.notes.map((note: any) => {
            return {
                ...note,
                created_at: dateTime(note.created_at),
                updated_at: dateTime(note.updated_at),
                expires_at: dateTime(note.expires_at),
            }
        });
    }

    if (facility.hours) {
        facility.hours = transformOpeningHours(facility.hours);
    }

    return facility;
}